import { IOAuthCallbackState } from './o-auth-callback.state';
import { AuthenticationStatuses } from '@mobile-data-access-enums';

export const oAuthCallbackState: IOAuthCallbackState = {
  authenticationStatus: AuthenticationStatuses.NONE,
  progressPercentage: 0
};
